import {
    GET_SEBEL_USERS,
    GET_SEBEL_USERS_SUCCESS,
    GET_SEBEL_USERS_FAIL,
    ADD_SEBEL_USER,
    ADD_SEBEL_USER_SUCCESS,
    ADD_SEBEL_USER_FAIL,
    UPDATE_SEBEL_USER,
    UPDATE_SEBEL_USER_SUCCESS,
    UPDATE_SEBEL_USER_FAIL,
    DELETE_SEBEL_USER,
    DELETE_SEBEL_USER_SUCCESS,
    DELETE_SEBEL_USER_FAIL,
    SET_SEBEL_USER_FIELD_ERRORS,
  } from './actionTypes'
  
  const initialState = {
    users: [],
    loading: false,
    error: null,
    status: null,
    fieldErrors: {}, // For field-specific validation errors
  };
  
  const sebelUserReducer = (state = initialState, action) => {
    switch (action.type) {
      case GET_SEBEL_USERS:
        return { ...state, loading: true };
  
      case GET_SEBEL_USERS_SUCCESS:
        return { ...state, loading: false, users: action.payload };
  
      case GET_SEBEL_USERS_FAIL:
        return { ...state, loading: false, error: action.payload };
  
      case ADD_SEBEL_USER:
        return { ...state, loading: true };
  
      case ADD_SEBEL_USER_SUCCESS:
        return {
          ...state,
          loading: false,
          status: 'success',
          fieldErrors: {},
        };
  
      case ADD_SEBEL_USER_FAIL:
        return { ...state, loading: false, error: action.payload };
  
      case UPDATE_SEBEL_USER:
        return { ...state, loading: true };
  
      case UPDATE_SEBEL_USER_SUCCESS:
        return {
          ...state,
          loading: false,
          fieldErrors: {},
        };
  
      case UPDATE_SEBEL_USER_FAIL:
        return { ...state, loading: false, error: action.payload };
  
      case DELETE_SEBEL_USER:
        return { ...state, loading: true };
  
      case DELETE_SEBEL_USER_SUCCESS:
        return { ...state, loading: false };
  
      case DELETE_SEBEL_USER_FAIL:
        return { ...state, loading: false, error: action.payload };
  
      case SET_SEBEL_USER_FIELD_ERRORS:
        return { ...state, fieldErrors: action.payload };
  
      default:
        return state;
    }
  };
  
  export default sebelUserReducer;
  